import { TVerifyOAuthTokenRequest, TVerifyOAuthTokenResponse } from "@/features/auth/types/verify-oauth-token";
import { TApiRes } from "@/types/api";
import { clientApi } from "@/utils/api";
import { setToken } from "@/utils/token";
import Cookies from "js-cookie";

// Consume a single-use OAuth handoff token minted server-side and persist the resulting admin session.
// Generic on purpose so future SSO/handoff flows into the admin app can reuse the same /auth/callback page.
export const verifyOAuthTokenApi = async (payload: TVerifyOAuthTokenRequest): Promise<TVerifyOAuthTokenResponse> => {
  const {
    data: { data },
  } = await clientApi.post<TApiRes<TVerifyOAuthTokenResponse>>("/oauth/verify-token", payload);

  setToken(data.accessToken, data.refreshToken);
  Cookies.set("admin-email", data.email);
  return data;
};
